import { lazy, Suspense, useContext, type ReactNode } from "react";
import { useLocation } from "react-router";
import { env } from "@/shared/config/env";
import { cat3dEnabled } from "./flags";
import type { Cat3DPosture } from "./behavior";
import { Cat3DSourceContext } from "./source";

/**
 * 小窝里包在原 2D 形象外面的挂载点（AVATAR-HOME-01，6796；HomeScene 由 6c2b 落盘）。
 * 开关关着（默认、live、没带 ?cat3d=1）时原样渲染 children：页面结构不变，不加载 Cat3DLayer、three、GLB，连样式也不加载。
 * 开着时才懒加载 Cat3DLayer；它上屏之前、以及任何降级情况下，显示的都是 children（原来的 2D 形象）。
 */
const Cat3DLayer = lazy(() => import("./Cat3DLayer").then((m) => ({ default: m.Cat3DLayer })));

export function Cat3DSlot({
  dataOrigin,
  room,
  posture,
  children,
}: {
  dataOrigin: string | null | undefined;
  room: "courtyard" | "inside";
  posture: Cat3DPosture;
  children: ReactNode;
}) {
  const { search } = useLocation();
  const src = useContext(Cat3DSourceContext);
  if (!cat3dEnabled({ dataMode: env.dataMode, dataOrigin, search })) return <>{children}</>;
  return (
    <Suspense fallback={children}>
      <Cat3DLayer room={room} posture={posture} src={src} fallback={children} />
    </Suspense>
  );
}
